const checkbox = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: '0',
        marginRight: 24,
      },
    },
  },
};

export default checkbox;
